/**
Project: Voice Panel (c)
Title: Voice Admin URLs
Description: URLs of the Voice Admin Panel
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
export const VoiceAdminURLProps = {
  home: "/",
  setup: "/setup",
  voiceSetup: "/setup/voice-setup",
  domainSetup: "/setup/domain-setup",
  routing: "/routing",
  accounts: "/accounts",
  users: "/accounts/users",
  policyUsers: "/accounts/users/:pid",
  serviceNumbers: "/accounts/calling-services",
  usersFilter: "/accounts/users/filter",
  usersList: "/accounts/users/list",
  numbers: "/numbers",
  controlDepartments: "/numbers/controls/departments",
  controlNumbertypes: "/numbers/controls/number-types",
  controlCarriers: "/numbers/controls/carriers",
  controlDevicetypes: "/numbers/controls/device-types",
  numberList: "/numbers/inventory",
  numberAdd: "/numbers/inventory/add",
  numberEdit: "/numbers/inventory/:nid/edit",
  numberOrder: "/numbers/buy-numbers",
};
